/**
 * tipos.ts — O que a ficha é, do lado do navegador.
 *
 * FUNCIONÁRIO É A PESSOA; USUÁRIO É O LOGIN. São entidades separadas (ver
 * `044_funcionarios.sql`), e a ficha pode existir sem login — pessoa em
 * experiência, extra de fim de semana.
 *
 * VÍNCULO ≠ FUNÇÃO, e por isso são dois campos (`045_funcoes_e_vinculo.sql`):
 * vínculo diz se a pessoa é empregada — é ele que decide quem entra em ponto,
 * férias e folha; função diz o que ela faz. A Luciana é sócia E vendedora; com
 * um campo só, qualquer valor mentiria.
 */

export type Vinculo = 'funcionario' | 'socio';
export type Situacao = 'ativo' | 'afastado' | 'desligado';

export interface Funcao {
  id: number;
  nome: string;
  descricao: string | null;
  ordem: number;
  status: string;
}

export interface Funcionario {
  id: number;
  usuario_id: number | null;
  usuario: string | null;
  perfil_nome: string | null;
  nome: string;
  apelido: string | null;
  vinculo: Vinculo;
  funcao_id: number | null;
  funcao_nome: string | null;
  cargo: string | null;
  cpf: string | null;
  rg: string | null;
  pis: string | null;
  nascimento: string | null;
  pix: string | null;
  pix_tipo: string | null;
  conta_salario: string | null;
  telefone: string | null;
  celular: string | null;
  email: string | null;
  endereco: string | null;
  bairro: string | null;
  cidade: string | null;
  foto: string | null;
  admissao: string | null;
  demissao: string | null;
  situacao: Situacao;
  observacoes: string | null;
  loja_id: number | null;
  loja_nome: string | null;
  loja_codigo: string | null;
  edicao_bloqueada: boolean;
  bloqueado_em: string | null;
}

/** Cor do selo de situação — mesma linguagem das outras listas do app. */
export const SITUACAO_BADGE: Record<Situacao, { classe: string; rotulo: string }> = {
  ativo: { classe: 'text-bg-success', rotulo: 'Ativo' },
  afastado: { classe: 'text-bg-warning', rotulo: 'Afastado' },
  desligado: { classe: 'text-bg-secondary', rotulo: 'Desligado' },
};

/** Sócio ganha selo; funcionário não — o comum não precisa de etiqueta. */
export const VINCULO_ROTULO: Record<Vinculo, string | null> = {
  funcionario: null,
  socio: 'Sócio',
};
